import { Component, OnDestroy } from '@angular/core';
import { BlockDragDropEventResponse, BlockListComponent } from 'components/layout/blocklist/blocklist.component';
import { CredentialType } from 'enums/CredentialType';
import { QualificationCallOverviewModel } from 'models/generated/Models.QualificationCallOverview';
import { UserQualificationCallViewModel } from 'models/generated/Models.UserQualificationCallView';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl } from 'services/navigation.service';
import { PushService } from 'services/push.service';
import { TaskService } from 'services/task.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'unassigned-qualification-calls',
	templateUrl: './unassigned-qualification-calls.component.html',
	imports: [Layout, BlockListComponent, TranslatePipe]
})
@ComponentUrl('unassigned-qualification-calls')
@CredentialRequired(CredentialType.BetaUserAccess)
export class UnassignedQualificationCallsComponent implements OnDestroy {

	onTaskflowChanges: Subscription;
	dragging = false;
	users: UserQualificationCallViewModel[] = [];
	qualificationCalls: QualificationCallOverviewModel[] = [];
	
	constructor(private userService: UserService, private taskService: TaskService, private pushService: PushService) {	
		this.getUsers();
		this.getUnAssignedQualificationCalls();

		this.onTaskflowChanges = this.pushService.onTaskflowChanges.subscribe((data) => {
			this.getUsers();
			this.getUnAssignedQualificationCalls();
		});
	}

	getUsers() {
		this.userService.getUsersWithQualificationCallData().then(users => {
			this.users = users;
		});
	}

	getUnAssignedQualificationCalls() {
		this.taskService.getUnAssignedQualificationCalls().then(qualificationCalls => {
			this.qualificationCalls = qualificationCalls;
		});
	}

	assignQualificationCallToUser(response: BlockDragDropEventResponse) {
		this.taskService.updateTaskActionAssignedToAndTaskflowOwner(response.dragId!, response.dropId!);
	}

	ngOnDestroy() {
		this.onTaskflowChanges.unsubscribe();
	}
}
